(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || !Element.prototype.animate || window.Shopify?.designMode) return;

  const selectors = [
    '.bl-section__head', '.bl-category-grid > .bl-category', '.product-grid > li',
    '.bl-journal-card', '.bl-hub-card', '.bl-manifesto__grid > div',
    '.bl-editorial__chapter', '.bl-editorial__figure', '.bl-detail',
    '.product__media-item:not(.is-active)', '.bl-media-gallery__item',
  ].join(',');
  const seen = new WeakSet();
  const animations = new Set();
  const observer = new IntersectionObserver((entries) => {
    let sequence = 0;
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      observer.unobserve(target);
      seen.add(target);
      if (reducedMotion.matches || target.contains(document.activeElement)) return;

      const compact = window.matchMedia('(max-width: 749px)').matches;
      // Content stays visible before JS and after interruption; no hidden loading state.
      const animation = target.animate([
        { opacity: 0.35, transform: `translateY(${compact ? 8 : 14}px)` },
        { opacity: 1, transform: 'translateY(0)' },
      ], {
        duration: compact ? 380 : 520,
        delay: compact ? 0 : Math.min(sequence++ * 55, 165),
        easing: 'cubic-bezier(.22, 1, .36, 1)',
        fill: 'backwards',
      });
      animations.add(animation);
      animation.finished.then(() => animations.delete(animation), () => animations.delete(animation));
    });
  }, { threshold: 0.08 });

  const observe = (root = document) => {
    if (reducedMotion.matches) return;
    root.querySelectorAll(selectors).forEach((element) => {
      if (!seen.has(element) && !element.parentElement.closest(selectors)) observer.observe(element);
    });
  };
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) {
      observer.disconnect();
      animations.forEach((animation) => animation.cancel());
    } else {
      observe();
    }
  });
  // Keyboard navigation never waits for an entrance animation to finish.
  document.addEventListener('focusin', (event) => {
    animations.forEach((animation) => {
      if (animation.effect.target.contains(event.target)) animation.cancel();
    });
  });
  observe();
})();
